import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getData, postData } from '../Services/api';
import { toast } from 'react-toastify';
import JoditEditor from 'jodit-react';

const AddProduct = () => {
    const [catList, setCatList] = useState([]);
    const [subCatList, setSubCatList] = useState([]);
    const editor = useRef(null);
    const [values, setValues] = useState({
        name: "",
        sku: "",
        price: "",
        offerPrice: "",
        categoryId: "",
        subCategoryId: "",
        shortDescription: "",
        description: "",
        specifications: [{ key: "", value: "" }],
        variants: [{ size: "", color: "", stock: "" }],
        images: [],
        mainImage: null,
        features: [""],
        isFeatured: false,
        isBestseller: false,
        isNewArrival: false,
        isPremium: false
    })
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setValues(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
            ...(name === "categoryId" && { subCategoryId: "" })
        }));
        // 👇 CATEGORY CHANGE PAR SUBCATEGORY FETCH
        if (name === "categoryId" && value) {
            fetchSubCategories(value);
        }
    };
    const handleMainImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setValues(prev => ({
                ...prev,
                mainImage: file
            }));
        }
    };

    const removeMainImage = () => {
        setValues(prev => ({
            ...prev,
            mainImage: null
        }));
    };

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);

        setValues(prev => ({
            ...prev,
            images: [...prev.images, ...files]   // allow multiple selection
        }));
    };


    const removeImage = (index) => {
        setValues(prev => ({
            ...prev,
            images: prev.images.filter((_, i) => i !== index)
        }));
    };

    const addSpec = () => {
        setValues(prev => ({
            ...prev,
            specifications: [...prev.specifications, { key: "", value: "" }]
        }));
    };

    const handleSpecChange = (i, field, value) => {
        const specs = [...values.specifications];
        specs[i][field] = value;
        setValues({ ...values, specifications: specs });
    };
    const removeSpec = (index) => {
        setValues(prev => ({
            ...prev,
            specifications: prev.specifications.filter((_, i) => i !== index)
        }));
    };
    const addFeature = () => {
        setValues(prev => ({
            ...prev,
            features: [...prev.features, ""]
        }));
    };

    const handleFeatureChange = (index, value) => {
        const updated = [...values.features];
        updated[index] = value;
        setValues({ ...values, features: updated });
    };
    const removeFeature = (index) => {
        setValues(prev => ({
            ...prev,
            features: prev.features.filter((_, i) => i !== index)
        }));
    };


    const addVariant = () => {
        setValues(prev => ({
            ...prev,
            variants: [...prev.variants, { size: "", color: "", stock: "" }]
        }));
    };

    const handleVariantChange = (i, field, value) => {
        const vars = [...values.variants];
        vars[i][field] = value;
        setValues({ ...values, variants: vars });
    };

    const removeVariants = (index) => {
        setValues(prev => ({
            ...prev,
            variants: prev.variants.filter((_, i) => i !== index)
        }));
    };

    const validateProducts = () => {
        toast.dismiss();

        if (!values.categoryId) {
            toast.error("Category is required");
            return false;
        }
        if (!values.subCategoryId) {
            toast.error("Sub Category is required");
            return false;
        }

        if (!values.name.trim()) {
            toast.error("Product name is required");
            return false;
        }

        if (!values.sku.trim()) {
            toast.error("SKU is required");
            return false;
        }

        if (!values.price || Number(values.price) <= 0) {
            toast.error("Valid price is required");
            return false;
        }

        if (
            values.offerPrice &&
            Number(values.offerPrice) >= Number(values.price)
        ) {
            toast.error("Offer price must be less than price");
            return false;
        }
        if (!values.mainImage) {
            toast.error("Main image is required");
            return false;
        }

        if (values.images.length === 0) {
            toast.error("At least one image is required");
            return false;
        }

        if (!values.shortDescription.trim()) {
            toast.error("Short description is required");
            return false;
        }

        // Specifications
        for (let i = 0; i < values.specifications.length; i++) {
            const s = values.specifications[i];
            if (!s.key.trim() || !s.value.trim()) {
                toast.error(`Fill all fields in specification ${i + 1}`);
                return false;
            }
        }

        // Variants (duplicate size+color)
        const variantSet = new Set();

        for (let i = 0; i < values.variants.length; i++) {
            const v = values.variants[i];

            if (!v.size || !v.color || !v.stock) {
                toast.error(`Fill all fields in variant ${i + 1}`);
                return false;
            }

            const key = `${v.size.toLowerCase()}-${v.color.toLowerCase()}`;
            if (variantSet.has(key)) {
                toast.error(`Duplicate variant: ${v.size} / ${v.color}`);
                return false;
            }

            variantSet.add(key);
        }
        for (let i = 0; i < values.features.length; i++) {
            if (!values.features[i].trim()) {
                toast.error(`Feature ${i + 1} cannot be empty`);
                return false;
            }
        }

        return true;
    };

    const fetchCategories = async () => {
        try {
            const res = await getData('/category/parents');
            if (res.status) {
                setCatList(res.data || [])
            }
        } catch (error) {
            console.log("error fetch categroy", error)
        }
    }
    const fetchSubCategories = async (id) => {
        try {
            const res = await getData(`/category/${id}/sub-categories`);
            if (res.status) {
                setSubCatList(res.data || [])
            }
        } catch (error) {
            console.log("error fetch sub categroy", error)
        }
    }

    useEffect(() => {
        fetchCategories();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateProducts()) return;
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("name", values.name);
            formData.append("sku", values.sku);
            formData.append("price", values.price);
            formData.append("offerPrice", values.offerPrice);
            formData.append("categoryId", values.categoryId);
            formData.append("subCategoryId", values.subCategoryId);
            formData.append("shortDescription", values.shortDescription);
            formData.append("description", values.description);

            formData.append("specifications", JSON.stringify(values.specifications));
            formData.append("variants", JSON.stringify(values.variants));
            formData.append("features", JSON.stringify(values.features));
            formData.append("mainImage", values.mainImage);
            values.images.forEach(img => formData.append("images", img));

            formData.append("isFeatured", values.isFeatured);
            formData.append("isBestseller", values.isBestseller);
            formData.append("isNewArrival", values.isNewArrival);
            formData.append("isPremium", values.isPremium);

            const res = await postData("/products", formData);
            if (res.status) {
                navigate('/products/product-list')
                toast.success(res.message);
            }
        } catch (error) {
            console.log("error products adding",)
            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                "Something went wrong";

            toast.error(message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        return () => {
            values.images.forEach(img => URL.revokeObjectURL(img));
        };
    }, [values.images]);

    return (
        <div className="pc-container">
            <div className="pc-content">
                <div className="page-header">
                    <div className="page-block">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/products/product-list">Products</Link>
                                    </li>
                                    <li className="breadcrumb-item" aria-current="page">
                                        Add Products
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-12">
                                <div className="page-header-question">
                                    <h2 className="mb-0">Add Products</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header">
                                <h5>Add Products</h5>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-sm-6 mb-3">
                                            <label className="form-label">Main Image (Thumbnail)</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                accept="image/*"
                                                onChange={handleMainImageChange}
                                            />

                                            {values.mainImage && (
                                                <div style={{ marginTop: "10px", position: "relative", width: "120px" }}>
                                                    <img
                                                        src={URL.createObjectURL(values.mainImage)}
                                                        alt="Main Preview"
                                                        style={{
                                                            width: "120px",
                                                            height: "120px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            border: "1px solid #ddd"
                                                        }}
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={removeMainImage}
                                                        style={{
                                                            position: "absolute",
                                                            top: "-8px",
                                                            right: "-8px",
                                                            background: "red",
                                                            color: "white",
                                                            border: "none",
                                                            borderRadius: "50%",
                                                            width: "22px",
                                                            height: "22px",
                                                            cursor: "pointer"
                                                        }}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-sm-6 mb-3">
                                            <label htmlFor="procut_image" className="form-label">
                                                Product Image
                                            </label>
                                            <input
                                                type="file"
                                                multiple
                                                className='form-control'
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                            <div style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "wrap" }}>
                                                {values.images.map((img, index) => (
                                                    <div key={index} style={{ position: "relative" }}>
                                                        <img
                                                            src={URL.createObjectURL(img)}
                                                            alt="preview"
                                                            style={{
                                                                width: "120px",
                                                                height: "120px",
                                                                objectFit: "cover",
                                                                borderRadius: "8px",
                                                                border: "1px solid #ddd"
                                                            }}
                                                        />

                                                        <button
                                                            type="button"
                                                            onClick={() => removeImage(index)}
                                                            className='image-remove-btn'
                                                            style={{
                                                                position: "absolute",
                                                                top: "-8px",
                                                                right: "-8px",
                                                                background: "red",
                                                                color: "white",
                                                                border: "none",
                                                                borderRadius: "50%",
                                                                width: "22px",
                                                                height: "22px",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            ✕
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">Category</label>
                                                <select className='form-select' name='categoryId' value={values.categoryId} onChange={handleChange}>
                                                    <option value="">Select Category</option>
                                                    {
                                                        catList?.map((cat) => {
                                                            return (
                                                                <option key={cat._id} value={cat._id}>{cat.cat_name}</option>

                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">Sub Category</label>
                                                <select className='form-select' name='subCategoryId' value={values.subCategoryId} disabled={!values.categoryId} onChange={handleChange}>
                                                    <option value="">Select Sub Category</option>
                                                    {
                                                        subCatList?.map((cat) => {
                                                            return (
                                                                <option key={cat._id} value={cat._id}>{cat.cat_name}</option>

                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">Product Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Product Name"
                                                    name='name'
                                                    value={values.name}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">Product SKU</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter SKU"
                                                    name='sku'
                                                    value={values.sku}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">Price</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Price"
                                                    name='price'
                                                    value={values.price}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">Offer Price</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Price"
                                                    name='offerPrice'
                                                    value={values.offerPrice}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Short Description</label>
                                                <textarea
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter short description"
                                                    name='shortDescription'
                                                    value={values.shortDescription}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Description</label>
                                                <JoditEditor
                                                    ref={editor}
                                                    value={values.description}
                                                    onChange={(newContent) =>
                                                        setValues(prev => ({
                                                            ...prev,
                                                            description: newContent
                                                        }))
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className='col-md-12'>
                                            <h5>Specifications</h5>
                                            {values.specifications.map((s, i) => {
                                                return (
                                                    <div className='row'>
                                                        <div className="col-md-5">
                                                            <div className="form-group">
                                                                <label className="form-label">Key</label>
                                                                <input placeholder="Key" className='form-control' onChange={e => handleSpecChange(i, "key", e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <div className="form-group">
                                                                <label className="form-label">Value</label>
                                                                <input placeholder="Value" className='form-control' onChange={e => handleSpecChange(i, "value", e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2 mt-5">
                                                            <button
                                                                type="button"
                                                                className='btn btn-danger'
                                                                onClick={() => removeSpec(i)}
                                                                style={{
                                                                    background: "red",
                                                                    color: "white",
                                                                    border: "none",
                                                                    borderRadius: "4px",
                                                                    padding: "0 8px",
                                                                    cursor: "pointer"
                                                                }}
                                                            >
                                                                ✕
                                                            </button>

                                                        </div>
                                                    </div>
                                                )
                                            })}
                                            <button type="button" onClick={addSpec} className="btn btn-outline-success">
                                                + Add Specification
                                            </button>
                                        </div>
                                        <div className='col-md-12 my-3'>
                                            <h5>Variants</h5>
                                            {values.variants.map((v, i) => (
                                                <div className='row'>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="form-label">Size</label>
                                                            <input placeholder="Size" className='form-control' onChange={e => handleVariantChange(i, "size", e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="form-label">Color</label>

                                                            <div className="d-flex gap-2 align-items-center">
                                                                <input
                                                                    type="color"
                                                                    className="form-control form-control-color"
                                                                    style={{ width: "55px" }}
                                                                    value={v.color}
                                                                    onChange={e => handleVariantChange(i, "color", e.target.value)}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={v.color}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="form-label">Stock</label>
                                                            <input type="number" className='form-control' placeholder="Stock" onChange={e => handleVariantChange(i, "stock", e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 mt-5">
                                                        <button
                                                            type="button"
                                                            onClick={() => removeVariants(i)}
                                                            style={{
                                                                background: "red",
                                                                color: "white",
                                                                border: "none",
                                                                borderRadius: "4px",
                                                                padding: "0 8px",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            ✕
                                                        </button>

                                                    </div>
                                                </div>
                                            ))}
                                            <button type="button" onClick={addVariant} className="btn btn-outline-success">+ Add Variant</button>
                                        </div>
                                        <div className='col-md-12'>
                                            <h5>Features</h5>

                                            {values.features.map((feature, i) => (
                                                <div className='row' key={i}>
                                                    <div className="col-md-10">
                                                        <div className="form-group">
                                                            <label className="form-label">Feature</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="e.g. 100% Cotton"
                                                                value={feature}
                                                                onChange={e => handleFeatureChange(i, e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-2 mt-5">
                                                        <button
                                                            type="button"
                                                            style={{
                                                                background: "red",
                                                                color: "white",
                                                                border: "none",
                                                                borderRadius: "4px",
                                                                padding: "0 8px",
                                                                cursor: "pointer"
                                                            }}
                                                            onClick={() => removeFeature(i)}
                                                        >
                                                            ✕
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}

                                            <button
                                                type="button"
                                                onClick={addFeature}
                                                className="btn btn-outline-success"
                                            >
                                                + Add Feature
                                            </button>
                                        </div>
                                        <div className='col-md-12'>
                                            <div className='row g-2'>
                                                <div className='col-md-3'>
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            name="isFeatured"
                                                            checked={values.isFeatured}
                                                            onChange={handleChange}
                                                        />
                                                        {" "}Featured
                                                    </label>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            name="isBestseller"
                                                            checked={values.isBestseller}
                                                            onChange={handleChange}
                                                        />
                                                        {" "}Bestseller
                                                    </label>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            name="isNewArrival"
                                                            checked={values.isNewArrival}
                                                            onChange={handleChange}
                                                        />
                                                        {" "}New Arrival
                                                    </label>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            name="isPremium"
                                                            checked={values.isPremium}
                                                            onChange={handleChange}
                                                        />
                                                        {" "}Premium
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-end btn-page mb-0 mt-4">
                                            <Link to="/products/product-list" className="btn btn-outline-secondary">Cancel</Link>
                                            <button className="btn btn-primary" type="submit" disabled={loading}>
                                                {loading ? 'Saving...' : 'Save'}
                                            </button>
                                        </div>
                                    </div>
                                </form >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddProduct